import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from 'react-18-image-lightbox';
import 'react-18-image-lightbox/style.css';

function LightBox({ imageUrl, onClose }) {
  return (
    <Lightbox
      mainSrc={imageUrl}
      onCloseRequest={onClose}
    />
  );
}

LightBox.propTypes = {
  onClose: PropTypes.func.isRequired,
  imageUrl: PropTypes.string.isRequired,
};

export default LightBox;
